@let availableARs = availableAccessRightsForRequest();
@if (files()?.length > 0 || links()?.length > 0) {
    <mulo-file-list #list displayMode="flat" listStyle="list">
        @for (
            file of files() | slice: 0 : (showAll() ? files()?.length : maxVisible());
            track file.esploroFileModel.mid
        ) {
            @let accessRightId = file.esploroFileModel?.accessRightsEsploroPolicyId;
            <mulo-file-list-item
                [baseName]="file.displayName"
                [extension]="file.esploroFileModel.fileExtension"
                [type]="file.esploroFileModel.fileMIMEType"
                [size]="file.esploroFileModel.fileSizeBytes"
                listStyle="list"
                [useListIcon]="true"
                [moreBtnLabel]="'research.aria.output.list.menu.more.options' | translate"
            >
                @if (file.haveAccessRight && availableARs?.includes(accessRightId)) {
                    <button
                        role="button"
                        mat-button
                        mulo-file-action
                        (click)="openReqForm(file.esploroFileModel)"
                        color="primary"
                    >
                        <mat-icon svgIcon="key"></mat-icon>
                        <span>{{ 'research.portal.fulldisplay.file.requestAccess' | translate }}</span>
                    </button>
                } @else if (file.haveAccessRight) {
                    <span
                        mulo-file-action
                        class="file-lock"
                        [matTooltip]="'research.portal.fulldisplay.file.access.restricted' | translate"
                    >
                        <mat-icon svgIcon="lock"></mat-icon>
                    </span>
                }
                @if (!file.haveAccessRight && file.downloadURL) {
                    <a
                        role="button"
                        mat-button
                        mulo-file-action
                        (click)="updateDownloadFileStatistics(file)"
                        [href]="file.downloadURL"
                        color="primary"
                        [attr.aria-label]="
                            'research.portal.fulldisplay.file.download.item' | translate: { value: file.displayName }
                        "
                        >{{ 'research.portal.fulldisplay.file.download' | translate }}</a
                    >
                }
                @if (!file.haveAccessRight && file.viewerLink) {
                    <a
                        role="button"
                        mat-button
                        mulo-file-action
                        color="primary"
                        (click)="updateViewFileStatistics(file)"
                        routerLink="."
                        [fragment]="'file-' + $index"
                        queryParamsHandling="preserve"
                        [replaceUrl]="true"
                        [attr.aria-label]="
                            'research.portal.fulldisplay.file.view.item' | translate: { value: file.displayName }
                        "
                    >
                        <mat-icon svgIcon="eye-outline"></mat-icon>
                        <span>{{ 'research.portal.fulldisplay.file.view' | translate }}</span>
                    </a>
                }
                <ng-template #iframeTemplate>
                    <button
                        mat-mini-fab
                        class="esp-viewer-dialog-close has-shadow"
                        matDialogClose
                        aria-label="{{ 'research.aria.dialog.close.dialog' | translate }}"
                    >
                        <mat-icon svgIcon="close"></mat-icon>
                    </button>
                    <esp-arcview-container
                        *ngIf="useArcview"
                        [items]="_filesAndLinks"
                        [currentIdx]="$index"
                        (currentIdxChange)="handleArcviewIdxChange($event)"
                        [currentRoute]="route"
                    ></esp-arcview-container>
                    <iframe *ngIf="!useArcview" [src]="getViewerLink(file)"></iframe>
                </ng-template>
                <ng-container *ngIf="getHasMetadata(file)">
                    <span
                        *ngIf="file.fileTypeLabel || isSupplementalFile(file)"
                        class="item-field"
                        [class.only-supplemental-field]="!file.fileTypeLabel"
                        >{{ getFileContentTypeText(file) }}</span
                    >
                    <span
                        *ngIf="file.esploroFileModel.fileDescriptionEsploro"
                        class="item-field"
                        [innerHTML]="file.esploroFileModel.fileDescriptionEsploro"
                    ></span>
                    <span class="item-field" *ngIf="file.licenseCode || file.accessRightStatement">
                        <ng-container *ngIf="file.licenseCode">
                            <span *ngIf="!file.licenseURL">{{ file.licenseCode + '.name' | translate }}</span>
                            <a *ngIf="file.licenseURL" [href]="file.licenseURL" target="_blank">{{
                                file.licenseCode + '.name' | translate
                            }}</a>
                        </ng-container>
                        <span *ngIf="file.accessRightStatement">
                            <ng-container *ngIf="file.licenseCode">,&nbsp;</ng-container>
                            {{ getFileAccessRightText(file) }}</span
                        >
                    </span>
                </ng-container>
            </mulo-file-list-item>
        }
        @for (
            link of links()
                | slice
                    : 0
                    : (showAll()
                          ? links()?.length
                          : files()?.length < maxVisible()
                            ? maxVisible() - files()?.length
                            : 0);
            track $index
        ) {
            <mulo-file-list-item
                [name]="getLinkTitle(link)"
                extension="url"
                type="url"
                listStyle="list"
                [useListIcon]="true"
                [moreBtnLabel]="'research.aria.output.list.menu.more.options' | translate"
            >
                <a
                    *ngIf="link?.viewerLink"
                    role="button"
                    mat-button
                    mulo-file-action
                    color="primary"
                    routerLink="."
                    [fragment]="'file-' + (files().length + $index)"
                    queryParamsHandling="preserve"
                    [replaceUrl]="true"
                    [attr.aria-label]="
                        'research.portal.fulldisplay.file.view.item' | translate: { value: getLinkTitle(link) }
                    "
                >
                    <mat-icon svgIcon="eye-outline"></mat-icon>
                    <span>{{ 'research.portal.fulldisplay.file.view' | translate }}</span>
                </a>
                <a
                    *ngIf="!link.viewerLink"
                    role="button"
                    mat-button
                    mulo-file-action
                    color="primary"
                    [href]="getViewerLink(link)"
                    target="_blank"
                    [attr.aria-label]="
                        'research.aria.output.list.title.open.asset' | translate: { value: getLinkTitle(link) }
                    "
                >
                    <mat-icon svgIcon="eye-outline"></mat-icon>
                    <span>{{ 'research.portal.fulldisplay.file.view' | translate }}</span>
                </a>
                <ng-template #iframeTemplate>
                    <button
                        mat-mini-fab
                        class="esp-viewer-dialog-close has-shadow"
                        matDialogClose
                        aria-label="{{ 'research.aria.dialog.close.dialog' | translate }}"
                    >
                        <mat-icon svgIcon="close"></mat-icon>
                    </button>
                    <esp-arcview-container
                        *ngIf="useArcview"
                        [items]="_filesAndLinks"
                        [currentIdx]="files().length + $index"
                        (currentIdxChange)="handleArcviewIdxChange($event)"
                        [currentRoute]="route"
                    ></esp-arcview-container>
                    <iframe *ngIf="!useArcview" [src]="getViewerLink(link)"></iframe>
                </ng-template>
                <ng-container *ngIf="getHasMetadata(link)">
                    <span
                        class="item-field"
                        *ngIf="link.linkTypeLabel || link.esploroAssetLinkModel?.linkSupplemental"
                        [class.only-supplemental-field]="!link.linkTypeLabel"
                        >{{ getLinkContentTypeText(link) }}</span
                    >
                    <span
                        class="item-field"
                        *ngIf="link.esploroAssetLinkModel?.linkDescription"
                        [innerHTML]="link.esploroAssetLinkModel.linkDescription"
                    ></span>
                    <span class="item-field" *ngIf="link.licenseCode || link.esploroAssetLinkModel?.linkRights">
                        <ng-container *ngIf="link.licenseCode">
                            <span *ngIf="!link.licenseURL">{{ link.licenseCode + '.name' | translate }}</span>
                            <a *ngIf="link.licenseURL" [href]="link.licenseURL" target="_blank">{{
                                link.licenseCode + '.name' | translate
                            }}</a>
                        </ng-container>
                        <span *ngIf="link.esploroAssetLinkModel?.linkRights">
                            <ng-container *ngIf="link.licenseCode">,&nbsp;</ng-container>
                            {{ 'esploro.accessRights.links.' + link.esploroAssetLinkModel.linkRights | translate }}
                        </span>
                    </span>
                </ng-container>
            </mulo-file-list-item>
        }
    </mulo-file-list>
}
<ng-template #requestFormDialog>
    <div class="position-relative">
        <button
            class="dialog-close-button"
            mat-icon-button
            matDialogClose
            [aria-label]="'research.aria.dialog.close.dialog' | translate"
        >
            <mat-icon svgIcon="close"></mat-icon>
        </button>
        <h2 mat-dialog-title>{{ 'research.portal.fulldisplay.file.requestAccess' | translate }}</h2>
        <form [formGroup]="accessRequestForm" class="padding-sm">
            <mat-form-field class="is-comfortably-readable">
                <mat-label>{{ 'research.portal.fulldisplay.file.requestAccess.name' | translate }}</mat-label>
                <input matInput formControlName="name" />
                <mat-error [innerHtml]="accessRequestForm?.get('name').errors | errorTranslate"></mat-error>
            </mat-form-field>
            <mat-form-field class="is-comfortably-readable">
                <mat-label>{{ 'research.portal.fulldisplay.file.requestAccess.email' | translate }}</mat-label>
                <input matInput formControlName="email" type="email" />
                <mat-error [innerHtml]="accessRequestForm?.get('email').errors | errorTranslate"></mat-error>
            </mat-form-field>
            <mat-form-field class="is-comfortably-readable">
                <mat-label>{{ 'research.portal.fulldisplay.file.requestAccess.orcid' | translate }}</mat-label>
                <input matInput formControlName="orcid" />
                <mat-error [innerHtml]="accessRequestForm?.get('orcid').errors | errorTranslate"></mat-error>
            </mat-form-field>
            @if (!accessRequestHideSendMeACopy) {
                <div>
                    <mat-checkbox formControlName="sendMeACopy">{{
                        'research.portal.fulldisplay.file.requestAccess.sendMeACopy' | translate
                    }}</mat-checkbox>
                </div>
            }
            <div>
                <h3>
                    {{
                        'research.portal.fulldisplay.file.requestAccess.files'
                            | translate: { count: requestFiles()?.length }
                    }}
                </h3>
            </div>
            <mulo-file-list displayMode="flat" listStyle="content">
                <mat-selection-list
                    class="mulo-elevation-list restricted-files-list"
                    [formControl]="accessRequestForm.get('files')"
                >
                    @for (rf of requestFiles(); track rf.esploroFileModel.mid) {
                        <mat-list-option [value]="rf.esploroFileModel.mid">
                            <mulo-file-list-item
                                [baseName]="rf.displayName"
                                [extension]="rf.esploroFileModel.fileExtension"
                                [type]="rf.esploroFileModel.fileMIMEType"
                                [size]="rf.esploroFileModel.fileSizeBytes"
                                listStyle="list"
                                [useListIcon]="true"
                                [moreBtnLabel]="'research.aria.output.list.menu.more.options' | translate"
                                [disableRipple]="true"
                            />
                        </mat-list-option>
                    }
                </mat-selection-list>
            </mulo-file-list>

            <mat-form-field class="full-width-field">
                <mat-label>{{ 'research.portal.fulldisplay.file.requestAccess.reason' | translate }}</mat-label>
                <textarea matInput formControlName="reason"></textarea>
                <mat-error [innerHtml]="'research.settings.field.required.error.message' | translate"></mat-error>
            </mat-form-field>
            <mat-form-field class="full-width-field">
                <mat-label>{{ 'research.portal.fulldisplay.file.requestAccess.use' | translate }}</mat-label>
                <textarea matInput formControlName="use"></textarea>
                <mat-error [innerHtml]="'research.settings.field.required.error.message' | translate"></mat-error>
            </mat-form-field>
            <div class="terms-wrap">
                <mat-checkbox formControlName="termsAndConditions" class="margin-zero"></mat-checkbox>
                <div class="terms-description">
                    {{ 'research.terms.click' | customTranslate }}

                    <a
                        (click)="openTermsDialog()"
                        [attr.aria-label]="'research.aria.deposit.terms.and.conditions.open' | translate"
                        >{{ 'research.terms.terms' | customTranslate }}</a
                    >

                    {{ 'research.terms.policy' | customTranslate }}
                </div>
            </div>
        </form>
        <mat-dialog-actions align="end">
            <button
                mat-button
                (click)="submitAccessRequestWithCaptcha()"
                [disabled]="accessRequestForm.invalid || accessRequestSubmitting()"
                color="primary"
            >
                <mat-icon class="mat-icon-rtl-mirror" svgIcon="send"></mat-icon>
                <span>{{ 'research.output.list.message.window.send' | translate }}</span>
            </button>
        </mat-dialog-actions>
    </div>
</ng-template>

<ng-container *ngIf="files()?.length + links()?.length > maxVisible()">
    <button *ngIf="!showAll()" mat-button color="primary" (click)="showAll.set(true)" class="all-toggle" hideOnPrint>
        <mat-icon svgIcon="chevron-down"></mat-icon>
        {{ 'research.portal.fulldisplay.details.showTheRest' | translate }}
    </button>
    <button
        *ngIf="showAll()"
        mat-raised-button
        color="primary"
        (click)="showAll.set(false)"
        class="all-toggle"
        hideOnPrint
    >
        <mat-icon svgIcon="chevron-up"></mat-icon>
        {{ 'research.general.showLess' | translate }}
    </button>
</ng-container>
@if (openURLLink()) {
    @if (files()?.length > 0 || links()?.length > 0) {
        <h3 class="subsection-title">{{ 'research.portal.fulldisplay.section.openURL' | translate }}</h3>
    }
    <div>
        @if (iframeLoading()) {
            <mulo-loading-slate height="{{ iframeHeight() }}px"></mulo-loading-slate>
        }

        <iframe
            width="100%"
            [src]="openURL()"
            role="presentation"
            [height]="iframeHeight()"
            (load)="handleIframeLoad($event)"
        ></iframe>
    </div>
}
